import { render, staticRenderFns } from "./WhenVisibile.vue?vue&type=template&id=5b4f5ac4&"
import script from "./WhenVisibile.vue?vue&type=script&lang=ts&"
export * from "./WhenVisibile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports